import { invoicePostingOutcome } from '@/lib/constants/invoices'

export const failureReason = (invoice) => {
  if (!invoice || !invoice.lastFailureMessage) return ''
  return invoice.lastFailureCategory
    ? `${invoice.lastFailureCategory}: ${invoice.lastFailureMessage}`
    : invoice.lastFailureMessage
}

const resultMessage = (succeeded, failed) => ({ outcome, invoice } = {}) => {
  const number = invoice ? invoice.vmsInvoiceId : ''
  if (outcome === invoicePostingOutcome.Posted) {
    return { success: true, message: `Invoice ${number} ${succeeded}` }
  }
  return { success: false, message: `Invoice ${number} was not ${failed}. ${failureReason(invoice)}`.trim() }
}

export const postingResultMessage = resultMessage('posted to QuickBooks', 'posted')

export const repostResultMessage = resultMessage('updated in QuickBooks', 're-posted')
